var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlotGames(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1250_327382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25586 3.19522V12.7362C1.25586 12.9389 1.42024 13.1033 1.62296 13.1033C1.82572 13.1033 1.99006 12.9389 1.99006 12.7362V3.19522C1.99006 2.99246 1.82572 2.82812 1.62296 2.82812C1.42024 2.82812 1.25586 2.99251 1.25586 3.19522Z",
    fill: "url(#paint0_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25586 3.19522V12.7362C1.25586 12.9389 1.42024 13.1033 1.62296 13.1033C1.82572 13.1033 1.99006 12.9389 1.99006 12.7362V3.19522C1.99006 2.99246 1.82572 2.82812 1.62296 2.82812C1.42024 2.82812 1.25586 2.99251 1.25586 3.19522Z",
    fill: "url(#paint1_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6671 2.03675L14.332 1.71416C14.2078 1.68417 14.0993 1.60886 14.0277 1.50301L13.2581 0.365415C13.165 0.227821 13.0224 0.153996 12.8757 0.14209C12.7289 0.153996 12.5863 0.227821 12.4932 0.365415L11.7236 1.50306C11.652 1.6089 11.5435 1.68417 11.4193 1.71421L10.0842 2.03679C9.72203 2.12428 9.57109 2.55655 9.80005 2.85045L10.6442 3.93393C10.7227 4.03473 10.7608 4.16118 10.7509 4.28858L10.6452 5.65799C10.6165 6.02946 10.9809 6.30654 11.3312 6.17959L12.6225 5.71161C12.7041 5.68202 12.7911 5.6744 12.8756 5.68748C12.9601 5.6744 13.0471 5.68202 13.1287 5.71161L14.42 6.17959C14.7703 6.30654 15.1347 6.02941 15.106 5.65799L15.0003 4.28858C14.9904 4.16118 15.0285 4.03473 15.107 3.93393L15.9512 2.85045C16.1802 2.5565 16.0293 2.12428 15.6671 2.03675Z",
    fill: "url(#paint2_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1281 5.71161L14.4194 6.17959C14.7697 6.30654 15.1341 6.02941 15.1054 5.65799L14.9997 4.28858C14.9898 4.16118 15.0279 4.03473 15.1064 3.93393L15.9506 2.85045C16.1795 2.55655 16.0286 2.12433 15.6664 2.03679L14.3314 1.71421C14.2072 1.68422 14.0986 1.6089 14.027 1.50306L13.2575 0.365415C13.1644 0.227821 13.0217 0.153996 12.875 0.14209V5.68748C12.9595 5.6744 13.0465 5.68202 13.1281 5.71161Z",
    fill: "url(#paint3_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6666 2.0369L14.3315 1.71431C14.2859 1.70331 14.2425 1.68608 14.2022 1.66357L10.7988 6.06568C10.9323 6.19471 11.1337 6.25108 11.3307 6.17974L12.622 5.71176C12.7035 5.68217 12.7906 5.67455 12.8751 5.68763C12.9595 5.67455 13.0466 5.68217 13.1281 5.71176L14.4194 6.17974C14.7697 6.30669 15.1341 6.02956 15.1055 5.65813L14.9997 4.28873C14.9899 4.16133 15.0279 4.03487 15.1065 3.93408L15.9506 2.8506C16.1797 2.55665 16.0287 2.12443 15.6666 2.0369Z",
    fill: "url(#paint4_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0841 2.0369L11.4192 1.71431C11.4648 1.70331 11.5082 1.68608 11.5485 1.66357L14.9519 6.06568C14.8184 6.19471 14.617 6.25108 14.4201 6.17974L13.1288 5.71176C13.0472 5.68217 12.9601 5.67455 12.8757 5.68763C12.7912 5.67455 12.7042 5.68217 12.6226 5.71176L11.3313 6.17974C10.981 6.30669 10.6166 6.02956 10.6453 5.65813L10.751 4.28873C10.7608 4.16133 10.7228 4.03487 10.6443 3.93408L9.80012 2.8506C9.57106 2.55665 9.72201 2.12443 10.0841 2.0369Z",
    fill: "url(#paint5_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72828 2.34619C9.66478 2.50629 9.68003 2.69705 9.79954 2.85048L10.6437 3.93396C10.7222 4.03475 10.7603 4.16121 10.7504 4.28861L10.6447 5.65801C10.616 6.02948 10.9804 6.30657 11.3307 6.17962L12.622 5.71163C12.7036 5.68205 12.7906 5.67443 12.8751 5.68751C12.9596 5.67443 13.0466 5.68205 13.1282 5.71163L14.4195 6.17962C14.7697 6.30657 15.1342 6.02944 15.1055 5.65801L14.9997 4.28861C14.9943 4.21794 15.0041 4.14768 15.0269 4.08179L9.72828 2.34619Z",
    fill: "url(#paint6_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0233 2.34619C16.0868 2.50629 16.0716 2.69705 15.9521 2.85048L15.1079 3.93396C15.0294 4.03475 14.9914 4.16121 15.0012 4.28861L15.1069 5.65801C15.1356 6.02948 14.7712 6.30657 14.4209 6.17962L13.1296 5.71163C13.048 5.68205 12.961 5.67443 12.8765 5.68751C12.7921 5.67443 12.705 5.68205 12.6234 5.71163L11.3322 6.17962C10.9819 6.30657 10.6174 6.02944 10.6461 5.65801L10.7519 4.28861C10.7573 4.21794 10.7475 4.14768 10.7248 4.08179L16.0233 2.34619Z",
    fill: "url(#paint7_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.528 3.39453H10.2246L10.6449 3.93399C10.7234 4.03479 10.7615 4.16124 10.7517 4.28865L10.6459 5.65805C10.6172 6.02952 10.9817 6.3066 11.3319 6.17965L12.6232 5.71167C12.7048 5.68208 12.7919 5.67446 12.8763 5.68754C12.9608 5.67446 13.0478 5.68208 13.1294 5.71167L14.4207 6.17965C14.771 6.3066 15.1354 6.02947 15.1067 5.65805L15.001 4.28865C14.9912 4.16124 15.0292 4.03479 15.1077 3.93399L15.528 3.39453Z",
    fill: "url(#paint8_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42441 4.18807L8.40799 3.94246C8.31342 3.9196 8.2308 3.86228 8.17632 3.78173L7.59041 2.91563C7.51952 2.81086 7.41096 2.75467 7.29921 2.74561C7.1875 2.75467 7.07891 2.81086 7.00801 2.91563L6.4221 3.78173C6.36758 3.86228 6.28496 3.91964 6.19043 3.94246L5.17401 4.18807C4.89828 4.25468 4.78342 4.58376 4.95772 4.80753L5.60037 5.63242C5.66017 5.70918 5.68912 5.80546 5.68163 5.90242L5.60109 6.945C5.57926 7.22781 5.85671 7.43878 6.12337 7.34213L7.10651 6.98581C7.16861 6.96331 7.23486 6.95749 7.29921 6.96746C7.36352 6.95749 7.42977 6.96331 7.49191 6.98581L8.47505 7.34213C8.74172 7.43878 9.0192 7.22781 8.99733 6.945L8.91679 5.90242C8.9093 5.80542 8.9383 5.70913 8.99805 5.63242L9.6407 4.80753C9.81505 4.58376 9.70014 4.25468 9.42441 4.18807Z",
    fill: "url(#paint9_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49153 6.98581L8.47467 7.34213C8.74133 7.43878 9.01882 7.22781 8.99695 6.945L8.9164 5.90242C8.90892 5.80542 8.93792 5.70913 8.99767 5.63242L9.64032 4.80753C9.81462 4.5838 9.69971 4.25468 9.42403 4.18807L8.40761 3.94246C8.31304 3.9196 8.23042 3.86228 8.17594 3.78173L7.59003 2.91563C7.51913 2.81086 7.41058 2.75467 7.29883 2.74561V6.9675C7.36318 6.95749 7.42943 6.96331 7.49153 6.98581Z",
    fill: "url(#paint10_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42468 4.18802L8.40826 3.94241C8.37358 3.93402 8.34052 3.9209 8.30981 3.90381L5.71875 7.25527C5.8204 7.35349 5.97373 7.39643 6.12369 7.34208L7.10682 6.98576C7.16892 6.96326 7.23517 6.95744 7.29953 6.96741C7.36384 6.95744 7.43009 6.96326 7.49223 6.98576L8.47537 7.34208C8.74203 7.43873 9.01952 7.22776 8.99765 6.94495L8.9171 5.90237C8.90962 5.80537 8.93861 5.70908 8.99837 5.63237L9.64102 4.80748C9.81532 4.58371 9.70041 4.25463 9.42468 4.18802Z",
    fill: "url(#paint11_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17402 4.18802L6.19044 3.94241C6.22512 3.93402 6.25818 3.9209 6.28889 3.90381L8.87996 7.25527C8.7783 7.35349 8.62497 7.39643 8.47502 7.34208L7.49188 6.98576C7.42978 6.96326 7.36353 6.95744 7.29918 6.96741C7.23487 6.95744 7.16862 6.96326 7.10648 6.98576L6.12334 7.34208C5.85667 7.43873 5.57919 7.22776 5.60106 6.94495L5.6816 5.90237C5.68909 5.80537 5.66009 5.70908 5.60034 5.63237L4.95769 4.80748C4.78343 4.58371 4.8983 4.25463 5.17402 4.18802Z",
    fill: "url(#paint12_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90308 4.42383C4.85474 4.54573 4.86633 4.69094 4.95733 4.80775L5.59998 5.63264C5.65978 5.70939 5.68873 5.80568 5.68125 5.90264L5.6007 6.94521C5.57887 7.22802 5.85632 7.43899 6.12298 7.34235L7.10612 6.98603C7.16822 6.96352 7.23447 6.95771 7.29882 6.96767C7.36313 6.95771 7.42938 6.96352 7.49153 6.98603L8.47466 7.34235C8.74133 7.43899 9.01882 7.22802 8.99695 6.94521L8.9164 5.90264C8.91225 5.84884 8.91969 5.79535 8.93706 5.7452L4.90308 4.42383Z",
    fill: "url(#paint13_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69469 4.42383C9.74303 4.54573 9.73144 4.69094 9.64044 4.80775L8.99779 5.63264C8.93799 5.70939 8.90904 5.80568 8.91652 5.90264L8.99707 6.94521C9.01889 7.22802 8.74145 7.43899 8.47479 7.34235L7.49165 6.98603C7.42955 6.96352 7.3633 6.95771 7.29894 6.96767C7.23463 6.95771 7.16839 6.96352 7.10624 6.98603L6.1231 7.34235C5.85644 7.43899 5.57895 7.22802 5.60082 6.94521L5.68137 5.90264C5.68552 5.84884 5.67808 5.79535 5.66071 5.7452L9.69469 4.42383Z",
    fill: "url(#paint14_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31892 5.22168H5.28125L5.60122 5.63239C5.66102 5.70914 5.68997 5.80543 5.68249 5.90239L5.60194 6.94497C5.58011 7.22778 5.85756 7.43874 6.12422 7.3421L7.10736 6.98578C7.16946 6.96328 7.23571 6.95746 7.30006 6.96743C7.36437 6.95746 7.43062 6.96328 7.49277 6.98578L8.4759 7.3421C8.74257 7.43874 9.02006 7.22778 8.99819 6.94497L8.91764 5.90239C8.91015 5.80538 8.93915 5.7091 8.99891 5.63239L9.31892 5.22168Z",
    fill: "url(#paint15_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5787 4.18807L19.5623 3.94246C19.4677 3.9196 19.3851 3.86228 19.3306 3.78173L18.7447 2.91563C18.6738 2.81086 18.5653 2.75467 18.4535 2.74561C18.3418 2.75467 18.2332 2.81086 18.1623 2.91563L17.5764 3.78173C17.5219 3.86228 17.4393 3.91964 17.3447 3.94246L16.3283 4.18807C16.0526 4.25468 15.9377 4.58376 16.112 4.80753L16.7547 5.63242C16.8145 5.70918 16.8434 5.80546 16.8359 5.90242L16.7554 6.945C16.7336 7.22781 17.011 7.43878 17.2777 7.34213L18.2608 6.98581C18.3229 6.96331 18.3892 6.95749 18.4535 6.96746C18.5178 6.95749 18.5841 6.96331 18.6462 6.98581L19.6293 7.34213C19.896 7.43878 20.1735 7.22781 20.1516 6.945L20.0711 5.90242C20.0636 5.80542 20.0926 5.70913 20.1524 5.63242L20.795 4.80753C20.9693 4.58376 20.8544 4.25468 20.5787 4.18807Z",
    fill: "url(#paint16_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6458 6.98581L19.629 7.34213C19.8956 7.43878 20.1731 7.22781 20.1512 6.945L20.0707 5.90242C20.0632 5.80542 20.0922 5.70913 20.152 5.63242L20.7946 4.80753C20.9689 4.5838 20.854 4.25468 20.5783 4.18807L19.5619 3.94246C19.4673 3.9196 19.3847 3.86228 19.3302 3.78173L18.7443 2.91563C18.6734 2.81086 18.5649 2.75467 18.4531 2.74561V6.9675C18.5174 6.95749 18.5837 6.96331 18.6458 6.98581Z",
    fill: "url(#paint17_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.579 4.18802L19.5626 3.94241C19.5279 3.93402 19.4948 3.9209 19.4641 3.90381L16.873 7.25527C16.9747 7.35349 17.128 7.39643 17.278 7.34208L18.2611 6.98576C18.3232 6.96326 18.3895 6.95744 18.4538 6.96741C18.5181 6.95744 18.5844 6.96326 18.6465 6.98576L19.6297 7.34208C19.8963 7.43873 20.1738 7.22776 20.1519 6.94495L20.0714 5.90237C20.0639 5.80537 20.0929 5.70908 20.1527 5.63237L20.7953 4.80748C20.9696 4.58371 20.8547 4.25463 20.579 4.18802Z",
    fill: "url(#paint18_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3283 4.18802L17.3447 3.94241C17.3794 3.93402 17.4125 3.9209 17.4432 3.90381L20.0342 7.25527C19.9326 7.35349 19.7793 7.39643 19.6293 7.34208L18.6462 6.98576C18.5841 6.96326 18.5178 6.95744 18.4535 6.96741C18.3892 6.95744 18.3229 6.96326 18.2608 6.98576L17.2776 7.34208C17.011 7.43873 16.7335 7.22776 16.7553 6.94495L16.8359 5.90237C16.8434 5.80537 16.8144 5.70908 16.7546 5.63237L16.112 4.80748C15.9377 4.58371 16.0526 4.25463 16.3283 4.18802Z",
    fill: "url(#paint19_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0574 4.42383C16.009 4.54573 16.0206 4.69094 16.1116 4.80775L16.7543 5.63264C16.8141 5.70939 16.843 5.80568 16.8355 5.90264L16.755 6.94521C16.7332 7.22802 17.0106 7.43899 17.2773 7.34235L18.2604 6.98603C18.3225 6.96352 18.3888 6.95771 18.4531 6.96767C18.5174 6.95771 18.5837 6.96352 18.6458 6.98603L19.629 7.34235C19.8956 7.43899 20.1731 7.22802 20.1512 6.94521L20.0707 5.90264C20.0665 5.84884 20.074 5.79535 20.0914 5.7452L16.0574 4.42383Z",
    fill: "url(#paint20_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.849 4.42383C20.8973 4.54573 20.8857 4.69094 20.7947 4.80775L20.1521 5.63264C20.0923 5.70939 20.0633 5.80568 20.0708 5.90264L20.1514 6.94521C20.1732 7.22802 19.8957 7.43899 19.6291 7.34235L18.6459 6.98603C18.5838 6.96352 18.5176 6.95771 18.4532 6.96767C18.3889 6.95771 18.3227 6.96352 18.2605 6.98603L17.2774 7.34235C17.0107 7.43899 16.7332 7.22802 16.7551 6.94521L16.8357 5.90264C16.8398 5.84884 16.8324 5.79535 16.815 5.7452L20.849 4.42383Z",
    fill: "url(#paint21_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4732 5.22168H16.4355L16.7555 5.63239C16.8153 5.70914 16.8443 5.80543 16.8368 5.90239L16.7562 6.94497C16.7344 7.22778 17.0119 7.43874 17.2785 7.3421L18.2617 6.98578C18.3238 6.96328 18.39 6.95746 18.4544 6.96743C18.5187 6.95746 18.5849 6.96328 18.6471 6.98578L19.6302 7.3421C19.8969 7.43874 20.1744 7.22778 20.1525 6.94497L20.0719 5.90239C20.0645 5.80538 20.0934 5.7091 20.1532 5.63239L20.4732 5.22168Z",
    fill: "url(#paint22_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17923 17.2704H1.14103C0.510871 17.2704 0 16.7596 0 16.1294V12.8647C0 12.2345 0.510871 11.7236 1.14103 11.7236H3.17928L3.17923 17.2704Z",
    fill: "url(#paint23_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.5449V16.1291C0 16.7592 0.510871 17.2701 1.14103 17.2701H3.17928V13.5449H0Z",
    fill: "url(#paint24_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6013 22.8579H4.14999C3.37787 22.8579 2.75195 22.232 2.75195 21.4599V9.50888C2.75195 8.73676 3.37787 8.11084 4.14999 8.11084H21.6013C22.3734 8.11084 22.9993 8.73676 22.9993 9.50888V21.4599C22.9993 22.232 22.3734 22.8579 21.6013 22.8579Z",
    fill: "url(#paint25_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1493 22.1812C3.75145 22.1812 3.42773 21.8575 3.42773 21.4597V9.50868C3.42773 9.11082 3.75145 8.78711 4.1493 8.78711H21.6006C21.9984 8.78711 22.3221 9.11082 22.3221 9.50868V21.4597C22.3221 21.8575 21.9984 22.1812 21.6006 22.1812H4.1493Z",
    fill: "url(#paint26_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75195 15.5747V21.46C2.75195 22.2321 3.37787 22.858 4.14999 22.858H21.6013C22.3734 22.858 22.9993 22.2321 22.9993 21.46V15.5747H2.75195Z",
    fill: "url(#paint27_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96767 9.46387H4.74812C4.39319 9.46387 4.10547 9.75159 4.10547 10.1065V20.8624C4.10547 21.2173 4.39319 21.505 4.74812 21.505H9.96767V9.46387Z",
    fill: "url(#paint28_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9668 9.46387H15.7839V21.505H9.9668V9.46387Z",
    fill: "url(#paint29_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0047 9.46387H15.7852V21.505H21.0047C21.3596 21.505 21.6474 21.2173 21.6474 20.8624V10.1065C21.6474 9.75159 21.3596 9.46387 21.0047 9.46387Z",
    fill: "url(#paint30_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17731 13.779C9.17731 14.0058 9.03773 14.346 8.8982 14.6076L6.85715 18.5153C6.78739 18.6462 6.65651 18.6985 6.47337 18.6985C6.04597 18.6985 5.60983 18.402 5.60983 18.0094C5.60983 17.9309 5.62724 17.8611 5.67089 17.7826L7.81661 14.0669V13.4563H6.25527V14.0407C6.25527 14.2762 5.9238 14.4593 5.56618 14.4593C5.19985 14.4593 4.89453 14.2762 4.89453 14.0407V12.6887C4.89453 12.4794 5.19114 12.27 5.48766 12.27H8.58414C8.84584 12.27 9.17727 12.4793 9.17727 12.6887V13.779H9.17731Z",
    fill: "url(#paint31_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0172 13.779C15.0172 14.0058 14.8776 14.346 14.738 14.6076L12.697 18.5153C12.6272 18.6462 12.4964 18.6985 12.3132 18.6985C11.8858 18.6985 11.4497 18.402 11.4497 18.0094C11.4497 17.9309 11.4671 17.8611 11.5107 17.7826L13.6565 14.0669V13.4563H12.0951V14.0407C12.0951 14.2762 11.7636 14.4593 11.406 14.4593C11.0397 14.4593 10.7344 14.2762 10.7344 14.0407V12.6887C10.7344 12.4794 11.031 12.27 11.3275 12.27H14.424C14.6857 12.27 15.0171 12.4793 15.0171 12.6887V13.779H15.0172Z",
    fill: "url(#paint32_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.857 13.779C20.857 14.0058 20.7174 14.346 20.5779 14.6076L18.5368 18.5153C18.4671 18.6462 18.3362 18.6985 18.1531 18.6985C17.7257 18.6985 17.2895 18.402 17.2895 18.0094C17.2895 17.9309 17.307 17.8611 17.3506 17.7826L19.4963 14.0669V13.4563H17.935V14.0407C17.935 14.2762 17.6035 14.4593 17.2459 14.4593C16.8795 14.4593 16.5742 14.2762 16.5742 14.0407V12.6887C16.5742 12.4794 16.8708 12.27 17.1673 12.27H20.2638C20.5255 12.27 20.857 12.4793 20.857 12.6887V13.779H20.857Z",
    fill: "url(#paint33_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96731 15.5747V21.5051H4.74812C4.39319 21.5051 4.10547 21.2174 4.10547 20.8625V15.5747H9.96731Z",
    fill: "url(#paint34_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9668 15.5747H15.784V21.5051H9.9668V15.5747Z",
    fill: "url(#paint35_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6474 15.5747V20.8625C21.6474 21.2174 21.3597 21.5051 21.0048 21.5051H15.7852V15.5747H21.6474Z",
    fill: "url(#paint36_linear_1250_327382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.623 4.142C2.44493 4.142 3.11124 3.47569 3.11124 2.65376C3.11124 1.83183 2.44493 1.16553 1.623 1.16553C0.801071 1.16553 0.134766 1.83183 0.134766 2.65376C0.134766 3.47569 0.801071 4.142 1.623 4.142Z",
    fill: "url(#paint37_linear_1250_327382)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1250_327382",
    x1: 1.35241,
    y1: 7.96569,
    x2: 2.21045,
    y2: 7.96569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1250_327382",
    x1: 1.623,
    y1: 5.29228,
    x2: 1.623,
    y2: 4.00699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1250_327382",
    x1: 11.4576,
    y1: 2.22206,
    x2: 14.0148,
    y2: 4.77921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1250_327382",
    x1: 14.4073,
    y1: 2.91927,
    x2: 10.8729,
    y2: 4.38045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A96C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#F6A96C",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A96C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1250_327382",
    x1: 13.4845,
    y1: 4.17369,
    x2: 11.5495,
    y2: 3.34438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A96C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#F6A96C",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A96C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1250_327382",
    x1: 12.2662,
    y1: 4.17369,
    x2: 14.2012,
    y2: 3.34438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A96C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#F6A96C",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A96C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1250_327382",
    x1: 12.3087,
    y1: 4.27066,
    x2: 13.5526,
    y2: 2.27146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A96C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#F6A96C",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A96C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1250_327382",
    x1: 13.347,
    y1: 4.0182,
    x2: 13.2434,
    y2: 2.06343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A96C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#F6A96C",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A96C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1250_327382",
    x1: 12.8763,
    y1: 4.49871,
    x2: 12.8763,
    y2: 6.67077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1250_327382",
    x1: 6.21956,
    y1: 4.32913,
    x2: 8.16645,
    y2: 6.27602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1250_327382",
    x1: 8.46542,
    y1: 4.85994,
    x2: 5.77456,
    y2: 5.97233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A96C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#F6A96C",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A96C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1250_327382",
    x1: 7.76345,
    y1: 5.81484,
    x2: 6.29023,
    y2: 5.18347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A96C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#F6A96C",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A96C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1250_327382",
    x1: 6.8353,
    y1: 5.81484,
    x2: 8.30847,
    y2: 5.18347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A96C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#F6A96C",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A96C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1250_327382",
    x1: 6.86764,
    y1: 5.88897,
    x2: 7.8147,
    y2: 4.36691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A96C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#F6A96C",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A96C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1250_327382",
    x1: 7.65711,
    y1: 5.69677,
    x2: 7.57819,
    y2: 4.20853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A96C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#F6A96C",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A96C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1250_327382",
    x1: 7.30011,
    y1: 6.06231,
    x2: 7.30011,
    y2: 7.71596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1250_327382",
    x1: 17.3739,
    y1: 4.32913,
    x2: 19.3207,
    y2: 6.27602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1250_327382",
    x1: 19.6197,
    y1: 4.85994,
    x2: 16.9288,
    y2: 5.97233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A96C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#F6A96C",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A96C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1250_327382",
    x1: 18.9177,
    y1: 5.81484,
    x2: 17.4445,
    y2: 5.18347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A96C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#F6A96C",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A96C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1250_327382",
    x1: 17.9896,
    y1: 5.81484,
    x2: 19.4628,
    y2: 5.18347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A96C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#F6A96C",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A96C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1250_327382",
    x1: 18.0219,
    y1: 5.88897,
    x2: 18.969,
    y2: 4.36691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A96C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#F6A96C",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A96C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1250_327382",
    x1: 18.8115,
    y1: 5.69677,
    x2: 18.7325,
    y2: 4.20853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A96C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#F6A96C",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A96C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1250_327382",
    x1: 18.4544,
    y1: 6.06231,
    x2: 18.4544,
    y2: 7.71596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1250_327382",
    x1: 0.594257,
    y1: 13.6843,
    x2: 2.39818,
    y2: 14.7216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBEC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81B823"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1250_327382",
    x1: 1.58962,
    y1: 15.3939,
    x2: 1.58962,
    y2: 17.1528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78A91F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78A91F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1250_327382",
    x1: 7.8764,
    y1: 10.4852,
    x2: 20.0312,
    y2: 22.6399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1250_327382",
    x1: 21.2307,
    y1: 23.8399,
    x2: 3.72732,
    y2: 6.33657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1250_327382",
    x1: 12.8756,
    y1: 19.0473,
    x2: 12.8756,
    y2: 22.7928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1250_327382",
    x1: 4.13961,
    y1: 12.3993,
    x2: 10.3242,
    y2: 18.5839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1250_327382",
    x1: 9.73184,
    y1: 12.341,
    x2: 16.0333,
    y2: 18.6425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1250_327382",
    x1: 15.4429,
    y1: 12.3993,
    x2: 21.6275,
    y2: 18.5839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1250_327382",
    x1: 4.86824,
    y1: 12.8862,
    x2: 9.43906,
    y2: 17.4571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1250_327382",
    x1: 10.708,
    y1: 12.8862,
    x2: 15.2789,
    y2: 17.4571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1250_327382",
    x1: 16.5479,
    y1: 12.8862,
    x2: 21.1187,
    y2: 17.4571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1250_327382",
    x1: 7.03639,
    y1: 18.1678,
    x2: 7.03639,
    y2: 21.7446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1250_327382",
    x1: 12.8754,
    y1: 18.1678,
    x2: 12.8754,
    y2: 21.7446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1250_327382",
    x1: 18.7163,
    y1: 18.1678,
    x2: 18.7163,
    y2: 21.7446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1250_327382",
    x1: 0.918028,
    y1: 1.94884,
    x2: 2.18104,
    y2: 3.21181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72B2B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1250_327382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlotGames);
export default __webpack_public_path__ + "static/media/SlotGames.430e6018397fd51c2a98bbc5537406fe.svg";
export { ForwardRef as ReactComponent };